import NoteTagModalContainer from './NoteTagModalContainer';

export default NoteTagModalContainer;
